var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set-Strategy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.400000006
  }, /*#__PURE__*/React.createElement("g", {
    id: "Strategy-Final-|-Opponents-Formation-(Desktop)-",
    transform: "translate(-1156.000000, -325.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-52-Copy-2",
    transform: "translate(1045.000000, 313.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(111.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22354035,1 L4.57050125,4.6530391 C4.35605953,4.86748083 4.35574898,5.21603213 4.57053734,5.43082049 C4.78488865,5.6451718 5.13355029,5.64562501 5.34831873,5.43085658 L9,1.7791753 L9,3.00039514 C9,3.27573496 9.22385763,3.5 9.5,3.5 C9.77558047,3.5 10,3.27631929 10,3.00039514 L10,0.499604863 C10,0.362000613 9.94408896,0.237152884 9.85368284,0.146679494 C9.76313906,0.0560512738 9.63829129,0 9.50039514,0 L6.99960486,0 C6.72426504,0 6.5,0.223857625 6.5,0.5 C6.5,0.775580475 6.72368071,1 6.99960486,1 L8.22354035,1 L8.22354035,1 Z M10,3.62314384 L10,8.75371233 C10,9.442018 9.50409845,10 8.89161706,10 L1.10838294,10 C0.49623995,10 0,9.4409289 0,8.75371233 L0,1.24628768 C0,0.557982 0.49590155,0 1.10838294,0 L6.44580853,0 L4,0 C4.27614238,0 4.5,0.223857625 4.5,0.5 C4.5,0.776142375 4.27614238,1 4,1 L1.28472424,1 C1.1256609,1 1,1.14934209 1,1.33356487 L1,8.66643512 C1,8.84733295 1.12747539,9 1.28472424,9 L8.71527576,9 C8.8743391,9 9,8.85065791 9,8.66643512 L9,6 C9,5.72385762 9.22385763,5.5 9.5,5.5 C9.77614237,5.5 10,5.72385762 10,6 L10,3.62314384 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCardIcon);
export default __webpack_public_path__ + "static/media/info-card-icon.50d0eade1808011cec3711274659e663.svg";
export { ForwardRef as ReactComponent };